import {StatisticsGrouping, StatisticsGroupingWrapper} from "./statistics-grouping";
import {Exclude, Expose} from "class-transformer";

export interface TimeStatistics extends StatisticsGrouping {
    dttm: number
}

@Exclude()
export class TimeStatisticsWrapper extends StatisticsGroupingWrapper implements TimeStatistics {
    @Expose()
    dttm: number

    constructor(dttm: number) {
        super()
        this.dttm = dttm
    }
}
